export default {
  container: {
    padding: '25px 20px',
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #ececec'
  },
  dense: {
    padding: '16px 20px'
  }
}
